export { default } from './container'



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-rate-limits/index.js